import template from './sw-order-detail-details.html.twig';

const { Component } = Shopware;

Component.override('sw-order-detail-details', {
    template,
});
